import {IHttpResponse} from 'api/models';
import {IGetFileByResourceIdApiResponse} from 'models';

const DEFAULT_FILE_NAME = 'download';

const readHeader = (headers: any, name: string): string | undefined => {
  if (!headers) {
    return undefined;
  }

  if (typeof headers.get === 'function') {
    return headers.get(name) ?? headers.get(name.toLowerCase()) ?? undefined;
  }

  return headers[name] ?? headers[name.toLowerCase()] ?? headers[name.toUpperCase()];
};

/**
 * Extract filename from Content-Disposition.
 * Supports: filename="x.pdf", filename=x.pdf, filename*=UTF-8''x.pdf
 */
const parseFileNameFromContentDisposition = (contentDisposition?: string): string | undefined => {
  if (!contentDisposition) {
    return undefined;
  }

  const starMatch = /filename\*\s*=\s*(?:UTF-8''|utf-8'')?([^;]+)/i.exec(contentDisposition);
  if (starMatch?.[1]) {
    try {
      return decodeURIComponent(starMatch[1].trim().replace(/^["']|["']$/g, ''));
    } catch {
      return starMatch[1].trim().replace(/^["']|["']$/g, '');
    }
  }

  const plainMatch = /filename\s*=\s*([^;]+)/i.exec(contentDisposition);
  if (plainMatch?.[1]) {
    return plainMatch[1].trim().replace(/^["']|["']$/g, '');
  }

  return undefined;
};

export const getContentResponseHeaders = (
  response: IHttpResponse<IGetFileByResourceIdApiResponse>,
  fallbackFileName: string = DEFAULT_FILE_NAME
) => {
  const mimeType = readHeader(response?.headers, 'content-type') ?? 'application/octet-stream';
  const contentDisposition = readHeader(response?.headers, 'content-disposition');
  const fileName = parseFileNameFromContentDisposition(contentDisposition) || fallbackFileName;

  return {mimeType, fileName};
};
